var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleMinus = function SvgCircleMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-3 -3 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.125a4.875 4.875 0 1 1 0 9.75 4.875 4.875 0 0 1 0-9.75M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12M4.938 6.438A.56.56 0 0 0 4.375 7c0 .312.25.563.563.563h4.125c.311 0 .562-.251.562-.563a.56.56 0 0 0-.562-.562z"
  })));
};
export default SvgCircleMinus;